import { Dropdown } from "react-bootstrap";
import React, { useState } from 'react';
// import { Dropdown } from 'react-bootstrap'; // Make sure to install react-bootstrap if you haven't already

import {
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
  LinkListItem,
} from "../../components";
import { MdDelete } from "react-icons/md";
import { handleDeleteCountry } from "../../pages/countries-manage/CountriesList";
import { createPortal } from "react-dom";
import instance from "../../pages/api";
import { ChevronDown } from "lucide-react";

import Swal from "sweetalert2";

export const userColumns = ({ setCountriesData }) => {
    const handleStatusUpdate = async (country_id, newStatus) => {
        try {
        // Make the PUT request to update the status
        await instance.put(
            `api/Master/Country/update/${country_id}`,
            { status: String(newStatus) }
        );

            // if (response.status === 200) {
            // console.log("Response is ok")
            // If the response is OK, update the state to reflect the new status
            setCountriesData((prevData) =>
            prevData.map((country) =>
                country.country_id === country_id
                ? { ...country, status: newStatus }
                : country
            )
            );
                        Swal.fire('Success', 'Country Status updated successfully!', 'success')

     
        } catch (error) {
            console.error("Error updating status:", error);
                        Swal.fire('Error', 'Failed to update Country Status!', 'error')

        }
    };
    
 
    
  return [
    {
      name: "Country ID",
      selector: (row) => row.country_id,
      cell: (row) => <span>{row.country_id}</span>,
      sortable: true,
    },

    {
      name: "Country Name",
      selector: (row) => row.name,
      cell: (row) => (
        <span className="small text" style={{ whiteSpace: "nowrap" }}>
          {row.name}
        </span>
      ),
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "ISO CODE2",
      selector: (row) => row.iso_code_2,
      cell: (row) => (
        <span className="small text" style={{ whiteSpace: "nowrap" }}>
          {row.iso_code_2}
        </span>
      ),
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "ISO CODE3",
      selector: (row) => row.iso_code_3,
      cell: (row) => (
        <span className="small text" style={{ whiteSpace: "nowrap" }}>
          {row.iso_code_3}
        </span>
      ),
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "Status",
      selector: (row) => row.status,
        cell: (row) => (
        <StatusCell row={row} onStatusChange={handleStatusUpdate} />
        // <div
        //   className={`d-flex justify-content-center align-items-center rounded`}
        //   style={{
        //     color: row.status === 1 ? "#198754" : "#dc3545", // Bootstrap success and danger text colors
        //     backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da", // Bootstrap success and danger light backgrounds
        //     width: "93px",
        //     height: "28px",
        //     cursor: "pointer",
        //   }}
        //   onClick={() => console.log(row.status)}
        // >
        //   {row.status == 1 ? "Active" : "Inactive"}
        // </div>
      ),
      sortable: true,
    },

    {
      name: "action",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu
                className="dropdown-menu-sm"
                as={CustomDropdownMenu}
                align="end"
              >
                <div className="dropdown-content py-1">
                  <LinkList className="link-list-hover-bg-primary link-list-md">
                    <LinkListItem
                      to={`/countries-manage/countries-list/${row.country_id}`}
                    >
                      <Icon name="edit"></Icon>
                      <span>Edit</span>
                    </LinkListItem>

                    <LinkListItem
                      className="delete-ittem"
                      to="#"
                      onClick={() =>
                        handleDeleteCountry(row.country_id, setCountriesData)
                      }
                    >
                      <MdDelete />
                      <span>Delete</span>
                    </LinkListItem>
                  </LinkList>
                </div>
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ];
};





const StatusCell = ({ row, onStatusChange }) => {


 const handleStatusChange = (newStatus) => {
    // Call the onStatusChange function passed from the parent
    onStatusChange(row.country_id, newStatus);
    // Hide the dropdown after selection
    // setDropdownVisible(false);
  };


  return (
     <div className="text-center ">
      <Dropdown>
        <Dropdown.Toggle
          size="sm"
          as={CustomDropdownToggle}
          className="btn-zoom"
        >
          <div
            className={`d-flex justify-content-center align-items-center rounded`}
            style={{
              color: row.status === 1 ? "#198754" : "#dc3545",
              backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da",
              width: "93px",
              height: "28px",
              cursor: "pointer",
            }}
          >
            {row.status === 1 ? "Active" : "Inactive"}{" "}
            {row.status === 1 ? (
              <ChevronDown color="#198754" size={18} />
            ) : (
              <ChevronDown color="#dc3545" size={18} />
            )}
          </div>
        </Dropdown.Toggle>
        {createPortal(
          <Dropdown.Menu
            className="dropdown-menu-sm"
            as={CustomDropdownMenu}
            align="end"
          >
            <div className="dropdown-content py-1">
              <LinkList className="link-list-hover-bg-primary link-list-md">
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(1)}
                >
                  Active
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(0)}
                >
                  Inactive
                </button>
              </LinkList>
            </div>
          </Dropdown.Menu>,
          document.body
        )}
      </Dropdown>
    </div>
  );
};






